// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close[data-v-7b37da6a] {\n  font-size: 20px;\n  position: absolute;\n  right: 20px;\n}", ""]);
// Exports
module.exports = exports;
